import { useState, useEffect } from 'react'
import { buscarClientes, guardarCliente, obtenerCliente } from '../../db/clientes'
import { formatearPeso } from '../../utils/formato'

export default function ModalSeleccionarCliente({ clienteSeleccionado, onSeleccionar }) {
  const [termino, setTermino] = useState('')
  const [clientes, setClientes] = useState([])
  const [modoAgregar, setModoAgregar] = useState(false)
  const [nombre, setNombre] = useState('')
  const [telefono, setTelefono] = useState('')
  const [guardando, setGuardando] = useState(false)

  useEffect(() => {
    if (!termino.trim()) {
      setClientes([])
      return
    }
    buscarClientes(termino).then(lista => {
      lista.sort((a, b) => (b.deuda || 0) - (a.deuda || 0))
      setClientes(lista)
    })
  }, [termino])

  async function handleGuardar() {
    if (!nombre.trim() || guardando) return
    setGuardando(true)
    const res = await guardarCliente({ nombre: nombre.trim(), telefono: telefono.trim() })
    const nuevo = await obtenerCliente(res.id)
    onSeleccionar(nuevo)
    setGuardando(false)
  }

  if (modoAgregar) {
    return (
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3 mb-1">
          <button
            onClick={() => setModoAgregar(false)}
            className="w-8 h-8 flex items-center justify-center text-tienda-muted"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M19 12H5M5 12l7-7M5 12l7 7" />
            </svg>
          </button>
          <span className="text-tienda-text font-semibold">Nuevo cliente</span>
        </div>
        <input
          autoFocus
          className="input-field"
          placeholder="Nombre *"
          value={nombre}
          onChange={e => setNombre(e.target.value)}
        />
        <input
          className="input-field"
          placeholder="Teléfono (10 dígitos)"
          value={telefono}
          onChange={e => setTelefono(e.target.value.replace(/\D/g, '').slice(0, 10))}
          type="tel"
          inputMode="numeric"
          maxLength={10}
        />
        <button
          onClick={handleGuardar}
          disabled={!nombre.trim() || guardando}
          className="btn-primary w-full text-center"
          style={{ opacity: !nombre.trim() ? 0.5 : 1 }}
        >
          {guardando ? 'Guardando...' : 'Guardar y seleccionar'}
        </button>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-3">
      <input
        autoFocus
        className="input-field"
        placeholder="Buscar cliente..."
        value={termino}
        onChange={e => setTermino(e.target.value)}
      />
      <div className="max-h-52 overflow-y-auto space-y-1.5">
        {!termino.trim() ? (
          <p className="text-tienda-muted text-sm text-center py-6">Escribe el nombre para buscar</p>
        ) : clientes.length === 0 ? (
          <p className="text-tienda-muted text-sm text-center py-6">No se encontraron clientes</p>
        ) : null}
        {clientes.map(c => (
          <button
            key={c._id}
            onClick={() => onSeleccionar(c)}
            className={`w-full flex items-center justify-between px-3 py-2.5 rounded-xl border transition-colors text-left
              ${clienteSeleccionado?._id === c._id
                ? 'bg-tienda-accent/10 border-tienda-accent'
                : 'bg-tienda-bg border-tienda-border active:bg-tienda-border'}`}
          >
            <div>
              <p className="text-tienda-text font-semibold text-sm">{c.nombre}</p>
              {c.telefono && <p className="text-tienda-muted text-xs">{c.telefono}</p>}
            </div>
            {(c.deuda || 0) > 0 && (
              <span className="badge-danger ml-2 flex-shrink-0">{formatearPeso(c.deuda)}</span>
            )}
          </button>
        ))}
      </div>
      <button
        onClick={() => setModoAgregar(true)}
        className="flex items-center justify-center gap-2 py-2.5 rounded-xl border border-dashed border-tienda-accent/50 text-tienda-accent text-sm font-semibold"
      >
        <span className="text-lg leading-none">+</span>
        Nuevo cliente
      </button>
    </div>
  )
}
